const getters = {
  getMasterProviders: (state) => state.masterProviders,
  getMasterProvider: (state) => state.masterProvider,
};

export default getters;